import {useDebugValue, useEffect} from 'react';

import {useInitialization} from '../../../hooks/useInitialization';

import {getObjectValues} from '../../../utils/object';

function useDestinationActions(data) {
    const {
        destinationEvents: {
            onSettingsChange,
            onCurrentValuesChange,
            onLatestValuesChange
        },
        initialDestinationSettings,
        changeDestinationSettings,
        initialDestinationValues,
        currentDestinationValues,
        latestDestinationValues,
        setAllDestinationValues,
        setAllDestinationValuesInitial
    } = data;

    const {
        isInitialized
    } = useInitialization();

    function setSettings(nextSettings) {
        changeDestinationSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialDestinationSettings);
    }

    function setIsTypeaheadInputFocus(isTypeaheadInputFocus) {
        setSettings({
            isTypeaheadInputFocus
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialDestinationSettings)]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setAllDestinationValuesInitial, [...getObjectValues(initialDestinationValues)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerCurrentValuesChange() {
        if (isInitialized) {
            onCurrentValuesChange(currentDestinationValues);
        }
    }, [...getObjectValues(currentDestinationValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerLatestValuesChange() {
        if (isInitialized) {
            onLatestValuesChange(latestDestinationValues);
        }
    }, [...getObjectValues(latestDestinationValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    const result = {
        setIsTypeaheadInputFocus,
        setAllDestinationValues
    };

    useDebugValue(result);

    return result;
}

export {useDestinationActions};
